module.exports = __webpack_public_path__ + "img/peoples.73b2be61.svg";